module.exports = __webpack_public_path__ + "static/img/celue-bg.f9c048a3.png";